<script setup>
const { $get } = useAxios();

const { data: performs, pending: isLoaded } = await useAsyncData(
  "get performs for performs list page",
  () => $get("/api/v3/perform?_sort=sort:asc")
);

const isActive = ref(true);
const activeOptions = ["Действующие", "Архив"];
const selectedGenres = ref([]);

const genres = computed(() => {
  const res = [];
  performs.value.forEach(({ genre }) => {
    if (!res.includes(genre)) {
      res.push(genre);
    }
  });
  return res;
});

function selectTypeOfPerforms(e) {
  if (e === activeOptions[0]) {
    isActive.value = true;
  } else {
    isActive.value = false;
  }
}

function selectGenre(genres) {
  selectedGenres.value = [];
  genres.forEach((genre) => {
    if (selectedGenres.value.indexOf(genre) === -1)
      selectedGenres.value.push(genre);
    else {
      selectedGenres.value.splice(selectedGenres.value.indexOf(genre), 1);
    }
  });
}

const performsToRender = computed(() => {
  let res = performs.value;

  res = res.filter((perform) => {
    if (perform.isActive === isActive.value) return perform;
    return false;
  });

  if (selectedGenres.value.length > 0) {
    res = res.filter((perform) => {
      if (selectedGenres.value.indexOf(perform.genre) !== -1) return perform;
    });
  }

  return res;
});
</script>

<template>
  <nuxt-layout name="default">
    <div v-if="!isLoaded">
      <r-section v-if="performs && performs?.length">
        <div
          class="flex flex-row flex-nowrap gap-x-10 relative"
          v-if="performs.length > 0"
        >
          <r-multy-select
            class="flex flex-col relative xl:min-w-1/3 xl:max-w-1/3"
            :options="activeOptions"
            @r:change="selectTypeOfPerforms"
            :is-multiple="false"
          ></r-multy-select>
          <div class="hidden xl:block w-0.5 bg-gray"></div>
          <r-multy-select
            class="hidden xl:flex flex-col relative max-w-2/3"
            :options="genres"
            @r:change="selectGenre"
            type="flex"
          ></r-multy-select>
        </div>
        <div
          class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-1 gap-7 mt-7"
          v-if="performsToRender.length > 0"
        >
          <r-perform-card-wide
            v-for="perform in performsToRender"
            :key="perform._id"
            :perform="perform"
          ></r-perform-card-wide>
        </div>
      </r-section>
    </div>
    <r-full-page-pro-loader v-else></r-full-page-pro-loader>
  </nuxt-layout>
</template>
